import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowListItem: Components<Theme>['MuiListItem'] = {
  defaultProps: {
    disablePadding: false,
    // controls left and right padding
    disableGutters: false,
  },
  styleOverrides: {
    root: {
      padding: '0',
      minHeight: '56px',
      // space between items
      margin: '4px 0',
      // space between children (e.g. icon/avatar and text)
      gap: '8px',
    },
    // default top & bottom padding (due to disablePadding: false)
    padding: {
      paddingTop: '4px',
      paddingBottom: '4px',
    },
    // default left & right padding (due to disableGutters: false)
    gutters: {
      paddingLeft: '4px',
      paddingRight: '4px',
      // divider after the item
      '& + .MuiDivider-root': {
        margin: '0 4px',
      },
      // extend button to cover whole ListItem
      '& > .MuiListItemButton-root': {
        marginLeft: '-4px',
        maxWidth: 'none',
      },
      '& > .MuiListItemButton-root:last-child': {
        marginRight: '-4px',
        maxWidth: 'none',
      },
      // workaround to avoid using :first-child selector which
      //  does not work with @emotion ssr
      '& > *:not(style) + .MuiListItemButton-root': {
        marginLeft: '0',
      },
    },
    // <List dense />
    dense: {
      marginTop: '0',
      marginBottom: '0',
      '&, & > .MuiListItemButton-root': {
        minHeight: '0',
      },
    },
  },
};
